import RoundedBox, { RoundedBoxProps } from 'ui/molecules/RoundedBox';
import { Center, Spinner } from '@chakra-ui/react';

const RoundedCard = ({
  children,
  loading,
  ...other
}: RoundedBoxProps & { loading?: boolean }) => (
  <RoundedBox shadow="card" {...other}>
    {loading && (
      <Center>
        <Spinner color="primaryColor" />
      </Center>
    )}
    {!loading && children}
  </RoundedBox>
);

export default RoundedCard;
